// Script pour mettre à jour dynamiquement les prix et images lors du changement de variante
// À ajouter dans Assets > variant-price-updater.js

document.addEventListener('DOMContentLoaded', function() {
  const variantPicker = document.querySelector('.simple-variant-picker');
  if (!variantPicker) return;

  const variantDataElement = document.querySelector('.simple-variant-picker__variants-json');
  if (!variantDataElement) return;

  const variantData = JSON.parse(variantDataElement.textContent);
  const radioInputs = document.querySelectorAll('.simple-variant-picker__radio');

  // Éléments de prix
  const priceBlock = document.querySelector('.shop-product-price-block');
  const comparePriceBlock = document.querySelector('.shop-compare-price');
  const saveBadge = document.querySelector('.shop-save-price');
  const addToCartButton = document.querySelector('.shop-add-to-cart-button');

  // Fonction pour formater le prix
  function formatMoney(cents) {
    const amount = cents / 100;
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);
  }

  // Fonction pour calculer le pourcentage de réduction
  function calculateDiscountPercentage(comparePrice, price) {
    return Math.round(((comparePrice - price) / comparePrice) * 100);
  }

  // Fonction pour mettre à jour les prix
  function updatePrices(variant) {
    if (!variant) return;

    // Mettre à jour le prix principal
    if (priceBlock) {
      priceBlock.textContent = formatMoney(variant.price);
      
      // Ajouter ou retirer la classe "on-sale"
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceBlock.classList.add('on-sale');
      } else {
        priceBlock.classList.remove('on-sale');
      }
    }

    // Mettre à jour le prix barré
    if (comparePriceBlock) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceBlock.textContent = formatMoney(variant.compare_at_price);
        comparePriceBlock.style.display = 'inline';
      } else {
        comparePriceBlock.style.display = 'none';
      }
    }

    // Mettre à jour le badge de réduction
    if (saveBadge) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const discountPercentage = calculateDiscountPercentage(variant.compare_at_price, variant.price);
        const saveText = saveBadge.textContent.split('%')[0].trim().replace(/\d+$/, '').trim();
        saveBadge.innerHTML = saveBadge.querySelector('svg') ? 
          saveBadge.querySelector('svg').outerHTML + ' ' + saveText + ' ' + discountPercentage + '%' :
          saveText + ' ' + discountPercentage + '%';
        saveBadge.style.display = 'inline-block';
      } else {
        saveBadge.style.display = 'none';
      }
    }

    // Mettre à jour le bouton "Ajouter au panier"
    if (addToCartButton) {
      const buttonText = addToCartButton.querySelector('.button-text');
      if (buttonText) {
        if (variant.available) {
          addToCartButton.disabled = false;
          addToCartButton.classList.remove('sold-out');
          
          // Mettre à jour le texte du bouton avec le prix si l'option est activée
          const priceInButton = buttonText.textContent.includes('-');
          if (priceInButton) {
            const baseText = buttonText.textContent.split('-')[0].trim();
            buttonText.textContent = baseText + ' - ' + formatMoney(variant.price);
          }
        } else {
          addToCartButton.disabled = true;
          addToCartButton.classList.add('sold-out');
          const soldOutText = window.variantStrings?.soldOut || 'Rupture de stock';
          buttonText.textContent = soldOutText;
        }
      }
    }

    // Déclencher un événement personnalisé pour d'autres scripts
    document.dispatchEvent(new CustomEvent('variant:priceChanged', {
      detail: {
        variant: variant,
        price: variant.price,
        compareAtPrice: variant.compare_at_price
      }
    }));
  }

  // Écouter les changements de variante
  radioInputs.forEach(radio => {
    radio.addEventListener('change', function() {
      // Récupérer toutes les options sélectionnées
      const selectedOptions = {};
      
      document.querySelectorAll('.simple-variant-picker__radio:checked').forEach(checkedRadio => {
        const position = checkedRadio.dataset.optionPosition;
        selectedOptions[`option${position}`] = checkedRadio.value;
      });

      // Trouver la variante correspondante
      const matchedVariant = variantData.find(variant => {
        return Object.keys(selectedOptions).every(key => 
          variant[key] === selectedOptions[key]
        );
      });

      if (matchedVariant) {
        updatePrices(matchedVariant);
      }
    });
  });

  // Initialiser avec la variante actuelle au chargement de la page
  const initialSelectedOptions = {};
  document.querySelectorAll('.simple-variant-picker__radio:checked').forEach(radio => {
    const position = radio.dataset.optionPosition;
    initialSelectedOptions[`option${position}`] = radio.value;
  });

  const initialVariant = variantData.find(variant => {
    return Object.keys(initialSelectedOptions).every(key => 
      variant[key] === initialSelectedOptions[key]
    );
  });

  if (initialVariant) {
    updatePrices(initialVariant);
  }
});